import {t} from "@lingui/core/macro";
import React from "react";

import Banner from "@khanacademy/wonder-blocks-banner";
import {Errors, type KAError} from "@khan/logging";

type SubmissionErrorBannerProps = {
    submitError?: KAError;
};

export default function SubmissionErrorBanner({
    submitError,
}: SubmissionErrorBannerProps) {
    if (!submitError) {
        return null;
    }

    const text = getBannerText(submitError);

    return <Banner kind="critical" text={text} layout="floating" />;
}

const getBannerText = (submitError: KAError) => {
    if (submitError.kind === Errors.InvalidInput) {
        if (submitError.message.includes("too long")) {
            return t`Uh oh! Input text is too long.`;
        }
        return t`Uh oh! Invalid input.`;
    }

    return t`Uh oh! Something went wrong.`;
};
